module.exports = __webpack_public_path__ + "static/img/1_5.6bbb04a5.jpg";